export default ({
    voucherButtonsContainer: {
        '@media print': {
            display: 'none'
        }
    }
})
